import React, { useRef } from "react";
import { postImg } from "service/api/blog";
import { ReactComponent as ImgIcon } from "assets/common/input/imgIcon.svg";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { IImages, ICasesDetail } from "service/interface/cases";

interface Props {
  imgData: IImages;
  data: ICasesDetail;
  setData: React.Dispatch<React.SetStateAction<ICasesDetail>>;
  idx: number;
}

export function CaseImgInput({ imgData, data, setData, idx }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files![0]) {
      const formData = new FormData();
      formData.append("image", e.target.files![0]);
      const imgRes = await postImg(formData);
      if (imgRes.status === responseCodeConstant.SUCCESS.ok) {
        const copiedArr = [...data.Images];
        copiedArr[idx] = { id: imgRes.data.data.id, src: imgRes.data.data.src };
        const filteredArr = copiedArr.filter((image) => image.id && image.src);
        setData((prev: any) => ({
          ...prev,
          Images: filteredArr,
        }));
      }
    }
  };

  const handleAddBtn = () => {
    inputRef.current?.click();
  };

  return (
    <div className="w-full">
      <input
        className="hidden"
        id="fileInput"
        type="file"
        accept="image/*"
        ref={inputRef}
        onChange={handleInputChange}
      />
      {imgData?.src ? (
        <div className="relative flex w-full items-center justify-center">
          <img
            src={imgData.src}
            alt="banner"
            className="max-h-[167px] max-w-[511px] cursor-pointer"
            onClick={handleAddBtn}
          />
        </div>
      ) : (
        <div
          onClick={handleAddBtn}
          className="flex w-full flex-col items-center justify-center"
        >
          <ImgIcon />
          <p className="m-0 text-M3 text-gray-3">이미지를 업로드해주세요.</p>
        </div>
      )}
    </div>
  );
}
